module.exports = __webpack_public_path__ + "img/man_biking.0e1db9f1.gif";